import { createAuthClient } from "better-auth/react";
import { MOCK_ADMIN, MOCK_ENABLED, MOCK_SESSION_KEY } from "./mock.ts";

const baseURL =
  (import.meta.env["VITE_API_BASE_URL"] as string | undefined) ??
  "https://api.currency-core.com";

export const authClient = createAuthClient({ baseURL });

// ---------------------------------------------------------------------------
// Mock auth (dev only — VITE_MOCK_AUTH=true). Any login input signs you in as
// the seeded platform admin so you can exercise every page without a backend.
// ---------------------------------------------------------------------------
const setLogin = (on: boolean) => {
  try {
    if (on) window.localStorage.setItem(MOCK_SESSION_KEY, "1");
    else window.localStorage.removeItem(MOCK_SESSION_KEY);
  } catch {
    /* ignore */
  }
};

function mockUseSession() {
  const loggedIn =
    typeof window !== "undefined" && window.localStorage.getItem(MOCK_SESSION_KEY) === "1";
  return {
    data: loggedIn ? { user: MOCK_ADMIN, session: { id: "sess_mock" } } : null,
    isPending: false,
    error: null,
  };
}

const mockSignIn = {
  email: async () => {
    setLogin(true);
    return { data: { user: MOCK_ADMIN }, error: null };
  },
  social: async (opts?: { callbackURL?: string }) => {
    setLogin(true);
    window.location.href = opts?.callbackURL ?? "/";
    return { data: null, error: null };
  },
};

const mockSignOut = async () => {
  setLogin(false);
  return { data: null, error: null };
};

export const useSession = MOCK_ENABLED
  ? (mockUseSession as unknown as typeof authClient.useSession)
  : authClient.useSession;
export const signIn = MOCK_ENABLED
  ? (mockSignIn as unknown as typeof authClient.signIn)
  : authClient.signIn;
export const signOut = MOCK_ENABLED
  ? (mockSignOut as unknown as typeof authClient.signOut)
  : authClient.signOut;
